import { CardApi } from '@intelingu/core/api/CardApi';
import { lazyInject } from '@intelingu/core/IoC/container';
import { TopicCardStore } from '@intelingu/core/stores/cards/TopicCardStore';
import { VocabularyCardStore } from '@intelingu/core/stores/cards/VocabularyCardStore';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { EvaluationMark, ExampleSentenceModel } from '@intelingu/core/interfaces/models/CardModel';
import { FormattedString } from '../../../partials/FormattedString';
import { SoundComponent } from '../../../partials/SoundComponent';
import {DisabledContent} from "../DisabledContent";

export interface SentenceTitleProps {
    sentence: ExampleSentenceModel;
    title: string;
    index?: number;
}

@observer export class SentenceTitle extends Component<SentenceTitleProps, any> {

    @lazyInject(CardApi) cardApi: CardApi;
    @lazyInject(VocabularyCardStore) vocabularyCardStore: VocabularyCardStore;
    @lazyInject(TopicCardStore) topicCardStore: TopicCardStore;

    @action.bound async expandTopic(e) {
        e.preventDefault();

        const response = await this.cardApi.getTopic(this.vocabularyCardStore.card.topic.id);
        this.topicCardStore.stack.push(response.data);
    }

    render() {
        const { sentence, title, index } = this.props;

        return <>
            { index > 0 && <div className={'sep'} /> }

            <div className={`sentence tour-enhancer-${index}`}>
                <div className={'title-wrapper'}>
                    <h1>{ title } { index === 1 && this.vocabularyCardStore.card.topic && (
                        <a href={''} onClick={this.expandTopic} className={'ml-2 text-white'}><i className={'ion ion-md-expand'} /></a>
                    ) }</h1>
                </div>

                { sentence.disabled ? (
                    <DisabledContent />
                ) : (
                    <>
                        <div className={'subtitle'}>
                            <FormattedString value={sentence.sentence} />
                        </div>

                        <SoundComponent
                            hotKeyListener={(event, play) => {
                                if (event.keyCode === (index ? 50 : 49) && event.altKey) {
                                    play();
                                }
                            }}
                            url={sentence.audio} />

                        {/*<div className={'description'} dangerouslySetInnerHTML={{ __html: sentence.translation }} />*/}
                        <div className={'description'}>
                            <FormattedString value={sentence.translation} />
                        </div>
                    </>
                ) }
            </div>
        </>
    }

}
